export default "__VITE_ASSET__81f5689b__"